export default "__VITE_ASSET__e300a4a7__"